import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";

export type VisitorScheduleField =
  | "start"
  | "end"
  | "host"
  | "guestName"
  | "guestOther"
  | "visitReason"
  | "location";

/** Conference room guest rows (flat `bookingType: conferencezone`). */
export function isConferenceVisitorRegistrationRow(
  visit: Pick<BookingScheduleInterface, "bookingType">
): boolean {
  return visit.bookingType === BookingType.CONFERENCEZONE;
}

type VisitorLocationContext = Pick<
  BookingScheduleInterface,
  | "bookingType"
  | "isVisitOnly"
  | "bookPlace"
  | "bookingInventoryId"
  | "visitorBookings"
  | "noPlaceZoneBookingId"
>;

/** Location is tied to a booked desk, room, or conference — not a free visit-only site picker. */
export function isVisitorLocationDerivedFromPlaceOrRoom(visit: VisitorLocationContext): boolean {
  if (isConferenceVisitorRegistrationRow(visit)) {
    return true;
  }
  if (visit.isVisitOnly === true) {
    return false;
  }
  if (visit.bookPlace === true) {
    return true;
  }
  if (visit.visitorBookings?.some(guest => guest.bookPlace === true)) {
    return true;
  }
  if (typeof visit.bookingInventoryId === "number" && visit.bookingInventoryId > 0) {
    return true;
  }
  return visit.noPlaceZoneBookingId != null;
}

function isVisitorLocationFieldEditable(visit: BookingScheduleInterface): boolean {
  if (isVisitorLocationDerivedFromPlaceOrRoom(visit)) {
    return false;
  }
  return !visit.checkedIn;
}

export function isVisitorScheduleFieldEditable(
  visit: BookingScheduleInterface,
  field: VisitorScheduleField
): boolean {
  if (field === "location") {
    return isVisitorLocationFieldEditable(visit);
  }

  if (isConferenceVisitorRegistrationRow(visit)) {
    if (field === "start" || field === "end" || field === "host") {
      return false;
    }
    if (field === "guestName" || field === "visitReason") {
      return !visit.checkedIn;
    }
    return true;
  }

  if (field === "guestName" || field === "host" || field === "visitReason") {
    return !visit.checkedIn;
  }
  if (field === "start") {
    return !visit.checkedIn;
  }
  return true;
}
